// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-listing-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.new-session-button {
  background-color: #0562fb !important;
  color: white !important;
  border-radius: 7px !important;
  transform: translateX(10px) !important;
}

.table-head-pos {
  font-size: 14px !important;
  text-align: center;
  font-weight: 700;
  padding: 5px !important;
}

.pos-table-main-box {
  width: 100% !important;
  margin-top: 25px;
}

.dark .pos-table-main-box > tbody {
  color: #fff !important;
}

.pos-table-main-box-new {
  width: 100% !important;
}

.dark .pos-table-main-box-new > tbody {
  color: #fff !important;
}

.table-data-pos {
  text-align: center;
  padding: 5px;
  font-weight: 600;
  font-size: 0.9rem;
}

@media (max-width: 500px) {
  .table-head-pos {
    padding: 10px !important;
  }
}

/* .dark .table-head-pos {
  background-color: white !important;
} */

tr,
td,
th {
  border: 0.1px solid rgba(128, 128, 128, 0.312);
}

.stop-day-button {
  background-color: #0562fb !important;
  color: white !important;
  border-radius: 7px !important;
}

.manager-validate-btn-fin {
  background-color: #0562fb !important;
  color: #fff !important;
  border-radius: 7px !important;
  padding: 5px 15px 5px 15px !important;
}

.soft-select-wrapper-I {
  width: 100%;
  border: 1px solid rgb(0, 0, 0);
  border-radius: 9px;
  margin-bottom: 10px !important;
}

.table-data-posRed {
  font-size: 0.8rem;
  color: red !important;
  font-weight: 600;
  padding: 5px;
  text-align: center;
}

.table-data-posGreen {
  font-size: 0.8rem;
  color: green !important;
  font-weight: 600;
  padding: 5px;
  text-align: center;
}

.auto-focus-btn:focus {
  border: 2px solid #0562fb !important;
}

.summary-button-wrapper {
  position: fixed;
  right: 20px;
  bottom: 20px;
}

.summary-button {
  border: 1px solid #ddd;
  transition:
    all 0.3s ease,
    transform 0.3s ease;
}

.summary-button:hover {
  border-color: #333;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  transform: translateY(-3px);
}

.summary-button svg {
  margin-right: 5px;
}

.summary-title {
  margin-bottom: 1rem;
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
  text-transform: uppercase;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.summary-main-box {
  border-radius: 10px;
  margin: 2rem;
}

.summary-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.newSessionListingContainer {
  width: 100%;
  padding-right: 10px;
}

.newSessionListingButtonContainer {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/SessionListing/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;;GAEG;;AAEH;;;EAGE,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB;;uBAEqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB","sourcesContent":[".session-listing-main {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.new-session-button {\n  background-color: #0562fb !important;\n  color: white !important;\n  border-radius: 7px !important;\n  transform: translateX(10px) !important;\n}\n\n.table-head-pos {\n  font-size: 14px !important;\n  text-align: center;\n  font-weight: 700;\n  padding: 5px !important;\n}\n\n.pos-table-main-box {\n  width: 100% !important;\n  margin-top: 25px;\n}\n\n.dark .pos-table-main-box > tbody {\n  color: #fff !important;\n}\n\n.pos-table-main-box-new {\n  width: 100% !important;\n}\n\n.dark .pos-table-main-box-new > tbody {\n  color: #fff !important;\n}\n\n.table-data-pos {\n  text-align: center;\n  padding: 5px;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 500px) {\n  .table-head-pos {\n    padding: 10px !important;\n  }\n}\n\n/* .dark .table-head-pos {\n  background-color: white !important;\n} */\n\ntr,\ntd,\nth {\n  border: 0.1px solid rgba(128, 128, 128, 0.312);\n}\n\n.stop-day-button {\n  background-color: #0562fb !important;\n  color: white !important;\n  border-radius: 7px !important;\n}\n\n.manager-validate-btn-fin {\n  background-color: #0562fb !important;\n  color: #fff !important;\n  border-radius: 7px !important;\n  padding: 5px 15px 5px 15px !important;\n}\n\n.soft-select-wrapper-I {\n  width: 100%;\n  border: 1px solid rgb(0, 0, 0);\n  border-radius: 9px;\n  margin-bottom: 10px !important;\n}\n\n.table-data-posRed {\n  font-size: 0.8rem;\n  color: red !important;\n  font-weight: 600;\n  padding: 5px;\n  text-align: center;\n}\n\n.table-data-posGreen {\n  font-size: 0.8rem;\n  color: green !important;\n  font-weight: 600;\n  padding: 5px;\n  text-align: center;\n}\n\n.auto-focus-btn:focus {\n  border: 2px solid #0562fb !important;\n}\n\n.summary-button-wrapper {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n}\n\n.summary-button {\n  border: 1px solid #ddd;\n  transition:\n    all 0.3s ease,\n    transform 0.3s ease;\n}\n\n.summary-button:hover {\n  border-color: #333;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\n  transform: translateY(-3px);\n}\n\n.summary-button svg {\n  margin-right: 5px;\n}\n\n.summary-title {\n  margin-bottom: 1rem;\n  text-align: center;\n  font-weight: bold;\n  font-size: 1.5rem;\n  text-transform: uppercase;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.summary-main-box {\n  border-radius: 10px;\n  margin: 2rem;\n}\n\n.summary-close-button {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n}\n\n.newSessionListingContainer {\n  width: 100%;\n  padding-right: 10px;\n}\n\n.newSessionListingButtonContainer {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
